"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _SidebarIntegrationsAPI = require("./SidebarIntegrationsAPI");

var _defineObjectTypeStore = _interopRequireDefault(require("crm_data/flux/defineObjectTypeStore"));

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _default = (0, _defineObjectTypeStore.default)({
  actionTypePrefix: _ActionNamespaces.SIDEBAR_INTEGRATIONS,
  fetch: _SidebarIntegrationsAPI.fetch
}).defineName('SidebarIntegrationsStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;